import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  // CardBody,
  // CardHeader,
  Col,
  Container,
  // Input,
  // Label,
  Row,
} from "react-bootstrap";
// import { _get, _put } from "../Utils/Helper";
import { useParams, useNavigate } from "react-router-dom";
import { _get, _post, _put } from "../../Utils/Helper";
import { Input, Button } from "antd";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
// import { Input } from "antd";

export default function Score() {
  const id = useParams().id;
  const navigate = useNavigate(); // Import and define navigate here
  interface FormType {
    query_type: string;
    mathematics: number;
    english: number;
    other_score: number;
    admission_no: string;
    name_of_applicant: string;
    last_class: string;
    others: string;
    applicant_id: string;
  }
  const _form: FormType = {
    query_type: "update_current_class",
    mathematics: 0,
    english: 0,
    other_score: 0,
    admission_no: "",
    name_of_applicant: "",
    last_class: "",
    others: "",
    applicant_id: "",
  };

  const [form, setForm] = useState(_form);
  const [errors, setErrors] = useState({});
  const [statusColor, setStatusColor] = useState("#0d6efd");
  const [statusText, setStatusText] = useState("Status");
  const [new_data, setNewData] = useState([]);
  const {  school_locations } = useSelector((state: RootState) => state.auth);


  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log({...form, id, query_type: "update-score", statusText,branch: 
      school_locations[0]?.branch_name})
    _post(
      "update_application_form",
      { ...form, id, query_type: "update-score", statusText,branch: school_locations[0]?.branch_name },
      (res) => {
        // Handle success
        // alert(JSON.stringify(res));
        toast.success("Score updated");
        console.log(res);

        if (statusText === "Pass") {
          navigate(`/entrance-exams-score/entrance-exams-score`);
        } else if (statusText === "Failed") {
          navigate(`/scorefeil/${id}`);
        }
      },
      (err) => {
        // Handle error
        console.log(err);
      }
    );
  };

  const maxScores: Record<string, number> = {
    mathematics: 20,
    english: 20,
    other_score: 20, 
  };
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    let score = Number(value);
    const maxScore = maxScores[name] || 20; // Default to 20 if not defined
  
    if (score > maxScore) {
      alert(`The maximum score for this subject is ${maxScore} marks.`);
      score = maxScore; // Reset to the max allowed
    } else if (score < 0) {
      alert("Score cannot be negative.");
      score = 0; // Reset negative values
    }
  
    setForm((prev) => ({
      ...prev,
      [name]: score, // Update the form state
    }));
  };
  

  const getSecScl = useCallback(() => {
    _get(
      `application_list?id=${id}&query_type=select_id`,
      (res) => {
        console.log(res);
        if (res.data.length) {
          setForm(res.data[0]);
        }
      },
      (err) => {
        // Handle error response
        console.log(err);
      }
    );
  }, [id]);
  const getSelectClassName = () => {
    _get(
      `get_class_management?query_type=select_class_name`,
      (res) => {
        setNewData(res.results);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    getSecScl();
    getSelectClassName();
  }, [getSecScl]);

  useEffect(() => {
    const mathematicsScore = Number(form.mathematics) || 0;
    const englishScore = Number(form.english) || 0;
    const othersScore = Number(form.other_score) || 0;
  
    const totalScore = mathematicsScore + englishScore + othersScore;
    const maxPossibleScore = 60; 
  
    const percentageScore = (totalScore / maxPossibleScore) * 100;
    // console.log(school_locations[0].branch_name);
  
    if (percentageScore < 50) {
      setStatusColor("#dc3545"); 
      setStatusText("Failed");
    } else {
      setStatusColor("#198754"); 
      setStatusText("Pass");
    }
  }, [form.mathematics, form.english, form.other_score]);
  


  return (
    <div>
      {/* <Container> */}
      <div className="page-wrapper">
        <div className="content content-two" />
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">Entrance Exams Score</h4>
                  </div>
                </div>

                {/* <center>
                  <CardHeader
                    style={{ color: "#fff", backgroundColor: "#5295fa" }}
                  >
                    Score
                  </CardHeader>
                </center> */}
                {/* {JSON.stringify(school_locations)} */}
                <CardBody>
                  <Row>
                    {/* {JSON.stringify(form)} */}
                    <Col md={4}>
                      <p>
                        <b>Application: No.</b> {form.applicant_id}
                      </p>
                    </Col>
                    <Col md={4}>
                      <p>
                        <b>Name:</b> {form.name_of_applicant}
                      </p>
                    </Col>
                    <Col md={4}>
                      <p>
                        <b>Last Class:</b> {form.last_class}
                      </p>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label>Mathematics</label>
                        <input
                          type="number"
                          className="form-control"
                          name="mathematics"
                          value={form.mathematics}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label>English Language</label>
                        <input
                          type="number"
                          className="form-control"
                          name="english"
                          value={form.english}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label>{form.others}</label>
                        <input
                          type="number"
                          className="form-control"
                          name="other_score"
                          value={form.other_score}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Row>
                  {/* <div className="col-xxl col-xl-3 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Assign Class</label>
                      <CommonSelect
                        className="select"
                        options={new_data.map((i: any) => ({
                          label: i.class_name,
                          value: i.class_name,
                        }))}
                        handleChange={(newValue: SingleValue<Option>) =>
                          setForm((prev) => ({
                            ...prev,
                            current_class: newValue ? newValue.value : "",
                          }))
                        }
                      />
                    </div>
                  </div> */}
                  <Col md={4} className="mt-3">
                    <Button style={{ backgroundColor: statusColor }}>
                      {statusText}
                    </Button>
                  </Col>
                  <center>
                    <Button
                      style={{ width: "5rem", background: "#5295fa" }}
                      className="mt-3"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </center>
                </CardBody>
              </div>
            </form>
          </div>
        </div>
        {/* </Container> */}
      </div>
    </div>
  );
}
